<div
	class="w-[88.5%] m-auto flex flex-col justify-between items-center min-h-full pb-3"
>
	<div class="w-full">
		<div class="flex ltr:justify-end rtl:justify-start">
			<a
				matSuffix
				mat-icon-button
				[mat-dialog-close]="false"
				class="w-[21px] h-[21px] rounded border-2 mb-[18px] flex justify-center"
			>
				<img class="m-auto" src="./assets/images/close-square.svg" alt="" />
			</a>
		</div>
		<p class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey">
			{{ 'GALLERY.YOUR_VIDEO' | translate }}
		</p>

		<div
			*ngIf="!video"
			class="text-center rounded-[6px] border-[#D9DBE9] border-dashed pb-[16px] mb-[18px] flex flex-col items-center justify-center"
		>
			<button class="mt-[18px] mb-12px">
				<label class="custom-file-upload cursor-pointer">
					<input
						class="cursor-pointer"
						type="file"
						multiple
						accept="video/mp4"
						(change)="videoChangeEvent($event)"
					/>
					<img class="m-auto" src="./assets/images/upload.svg" alt="" />
					<h1
						class="text-dark-grey text-font-16 font-normal leading-[24px] m-0"
					>
						{{ 'ACTIONS.UPLOAD_VIDEO' | translate }}
					</h1>
					<p class="text-medium-gray text-font-12">
						{{ 'GALLERY.VIDEO_SIZE' | translate }}
					</p>
				</label>
			</button>
		</div>
		<div
			*ngIf="video"
			class="text-center rounded-[6px] border-[#D9DBE9] border px-[16px] py-[16px] mb-[18px] flex items-center justify-between"
		>
			<div class="inline-flex text-dark-grey justify-start items-center">
				<img src="assets/images/video-icon.svg" />
				<div class="mx-2 ltr:text-left rtl:text-right">
					<p class="m-0">{{ video?.name }}</p>
					<p class="m-0">
						{{ 'GALLERY.FILE_SIZE' | translate : { size: video?.size } }}
					</p>
				</div>
			</div>
			<img
				(click)="video = null"
				class="bg-white rounded-full p-2 w-9"
				src="assets/images/delete.svg"
				alt=""
			/>
		</div>
		<small *ngIf="videoError" class="text-red-error">
			{{ 'ERROR_MESSAGES.VIDEO_SIZE' | translate }}
		</small>
		<p class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey">
			{{ 'GALLERY.VIDEO_COVER' | translate }}
		</p>
		<div
			*ngIf="!image"
			class="text-center rounded-[6px] border-[#D9DBE9] border-dashed pb-[16px] mb-[18px] flex flex-col items-center justify-center"
		>
			<button class="mt-[18px] mb-12px">
				<label class="custom-file-upload cursor-pointer">
					<input
						class="cursor-pointer"
						type="file"
						multiple
						accept="image/png, image/jpeg, image/jpg"
						(change)="imageChangeEvent($event)"
					/>
					<img class="m-auto" src="./assets/images/upload.svg" alt="" />
					<h1
						class="text-dark-grey text-font-16 font-normal leading-[24px] m-0"
					>
						{{ 'ACTIONS.UPLOAD_IMG' | translate }}
					</h1>
				</label>
			</button>
		</div>
		<div
			*ngIf="image"
			class="text-center rounded-[6px] border-[#D9DBE9] border px-[16px] py-[16px] mb-[18px] flex items-center justify-between"
		>
			<div class="inline-flex text-dark-grey justify-start items-center">
				<img src="assets/images/image-icon.svg" />
				<div class="mx-2 ltr:text-left rtl:text-right">
					<p class="m-0">{{ image?.name }}</p>
					<p class="m-0">
						{{ 'GALLERY.FILE_SIZE' | translate : { size: image?.size } }}
					</p>
				</div>
			</div>
			<img
				(click)="image = null"
				class="bg-white rounded-full p-2 w-9"
				src="assets/images/delete.svg"
				alt=""
			/>
		</div>
		<small *ngIf="sizeError" class="text-red-error">
			{{ 'ERROR_MESSAGES.IMAGE_SIZE' | translate }}
		</small>
	</div>
	<button
		mat-button
		[disabled]="!video || !image"
		(click)="uploadThumbnail()"
		class="w-100 bg-gradient text-white w-full rounded-[6px] mt-4"
	>
		{{ 'ACTIONS.SAVE' | translate }}
	</button>
	<button
		class="w-full mt-3 text-medium-gray bg-transparent border border-solid border-light-grey"
		[mat-dialog-close]="false"
		mat-button
	>
		{{ 'ACTIONS.CANCEL' | translate }}
	</button>
</div>
